/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloadlinkscolumncreated3Inputs */

const en_downloadlinkscolumncreated3 = /** @type {(inputs: Downloadlinkscolumncreated3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

const de_downloadlinkscolumncreated3 = /** @type {(inputs: Downloadlinkscolumncreated3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt`)
};

/**
* | output |
* | --- |
* | "Created" |
*
* @param {Downloadlinkscolumncreated3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinkscolumncreated3 = /** @type {((inputs?: Downloadlinkscolumncreated3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinkscolumncreated3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinkscolumncreated3(inputs)
	return de_downloadlinkscolumncreated3(inputs)
});
export { downloadlinkscolumncreated3 as "downloadLinksColumnCreated" }